export default {
  namespaced: true,
  state: {
    image: null,
    imageArray: [],
    arrayIndex: 0,
    loading: false
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_IMAGE(state, payload) {
      state.image = payload;
    },
    SET_IMAGE_ARRAY(state, payload) {
      state.imageArray = payload;
    },
    SET_ARRAY_INDEX(state, payload) {
      state.arrayIndex = payload;
    },
    INCREMENT_INDEX(state) {
      state.arrayIndex += 1;
      if (state.arrayIndex >= (state.imageArray.length)) {
        state.arrayIndex = 0;
      }
    },
    DECREMENT_INDEX(state) {
      state.arrayIndex -= 1;
      if (state.arrayIndex <= -1) {
        state.arrayIndex = (state.imageArray.length - 1);
      }
    }
  },
  actions: {
    async modalize (context, payload) {
      context.commit('SET_LOADING', true);
      context.commit('SET_IMAGE', payload.image);
      context.commit('SET_IMAGE_ARRAY', payload.imageArray);
      context.commit('SET_ARRAY_INDEX', payload.imageArray.indexOf(payload.image));
      context.commit('SET_LOADING', false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/image-modal.store.js